<template>
  <span>
    <v-row dense justify="center" class="mt-5">
      <v-col
        v-for="indicador in listaKpisCardInicial"
        :key="indicador"
        cols="5"
        sm="3"
        md="auto"
        class="flex-md-grow-1"
      >
        <v-card class="my-1 elevation-0">
          <template>
            <v-card-title>
              <v-tooltip bottom v-if="traducaoIndicadores[indicador] != null">
                <template v-slot:activator="{ on }">
                  <h5 v-on="on">{{ indicador | toUpperCase }}</h5>
                </template>
                <span>{{ traducaoIndicadores[indicador] }}</span>
              </v-tooltip>
              <h5 v-else>{{ indicador | toUpperCase }}</h5>
              <status-evolucao-kpis
                class="ml-1"
                :valorAtual="dadosKpisTotalizados[indicador] || 0"
                :valorAnterior="
                  dadosKpisTotalizadosCompetenciaAnterior[indicador] || 0
                "
              />
              <template v-if="loadingPorChave.kpisTotalizados">
                <v-card-text
                  class="d-flex align-center justify-center"
                  style="height: 75px;"
                >
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    size="40"
                  />
                </v-card-text>
              </template>
              <v-card-text v-else>
                <div class="display-3">
                  {{
                    dadosKpisTotalizados[indicador]
                      | parseNumberToFloatBrIgnoringNaN
                  }}
                </div>
              </v-card-text>
            </v-card-title>
          </template>
        </v-card>
      </v-col>
    </v-row>

    <dashboard-faturamento-visao-aneel-cards-tipologias
      :dadosTipologiaFaturasSemLeitura="dadosTipologiaFaturasSemLeitura"
      :dadosTipologiaAcertosFaturamento="dadosTipologiaAcertosFaturamento"
      :exportingOptions="exportingOptions"
      :loading="loadingPorChave"
    />

    <dashboard-faturamento-visao-aneel-cards-kpis-por-competencia
      :dados="dadosCardsKpisPorCompetencia"
      :metasKpis="metasKpis"
      :categories="categories"
      :exportingOptions="exportingOptions"
      :loading="loadingPorChave"
    />
  </span>
</template>

<script>
import DashboardFaturamentoService from "@/services/DashboardFaturamentoService";

import Highcharts from "highcharts";
import HighchartsNoData from "highcharts/modules/no-data-to-display";
HighchartsNoData(Highcharts);
import exporting from "highcharts/modules/exporting";
import exportData from "highcharts/modules/export-data";
exporting(Highcharts);
exportData(Highcharts);

import dayjs from "dayjs";

export default {
  name: "DashboardLnoVisaoAneel",
  components: {
    StatusEvolucaoKpis: () =>
      import("@/components/dashboardLno/StatusEvolucaoKpis.vue"),
    DashboardFaturamentoVisaoAneelCardsTipologias: () =>
      import(
        "@/components/dashboardFaturamento/DashboardFaturamentoVisaoAneelCardsTipologias.vue"
      ),
    DashboardFaturamentoVisaoAneelCardsKpisPorCompetencia: () =>
      import(
        "@/components/dashboardFaturamento/DashboardFaturamentoVisaoAneelCardsKpisPorCompetencia.vue"
      ),
  },
  props: {
    competencia: {
      type: String,
      required: true,
    },
    categories: {
      type: Array,
      required: true,
    },
    activatedTab: {
      type: Number,
      required: true,
    },
    traducaoIndicadores: {
      type: Object,
      default: {},
    },
    regionalSelecionada: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    listaKpisCardInicial: ["psl", "prf", "pcf"],
    dadosKpisTotalizados: {},
    metasKpis: {},
    dadosKpisTotalizadosCompetenciaAnterior: {},
    dadosTipologiaFaturasSemLeitura: {},
    dadosTipologiaAcertosFaturamento: {},
    dadosCardsKpisPorCompetencia: {},
    loadingPorChave: {
      kpisTotalizados: false,
      metasKpis: false,
      dadosKpisTotalizadosCompetenciaAnterior: false,
      dadosTipologiaFaturasSemLeitura: false,
      dadosTipologiaAcertosFaturamento: false,
      dadosCardsKpisPorCompetencia: false,
    },
    exportingOptions: {
      enabled: true,

      buttons: {
        contextButton: {
          align: "left",
          verticalAlign: "bottom",
          menuItems: [
            {
              textKey: "downloadPNG",
              text: "Baixar como PNG",
              onclick: function() {
                this.exportChart();
              },
            },
            {
              separator: true,
            },
            {
              textKey: "downloadCSV",
              text: "Baixar como CSV",
              onclick: function() {
                this.downloadCSV();
              },
            },
            {
              textKey: "downloadXLS",
              text: "Baixar como XLS",
              onclick: function() {
                this.downloadXLS();
              },
            },
          ],
        },
      },
    },
  }),
  mounted() {
    this.getDados();
  },
  methods: {
    getDados() {
      // Apenas atualiza os dados se for a visao selecionada
      if (this.activatedTab !== 1) return;

      this.$emit("updateLoadingDados", true);

      Promise.allSettled([
        this.getDadosKpisTotalizados(),
        this.getMetasKpisGeral(),
        this.getDadosKpisTotalizadosCompetenciaAnterior(),
        this.getDadosTipologiaFaturasSemLeitura(),
        this.getDadosTipologiaAcertosFaturamento(),
        this.getDadosKpisPorCompetencia(),
      ])
        .then((results) => {
          const hasError = results.some(
            (result) => result.status === "rejected",
          );
          if (hasError) {
            this.$toast.error("Erro ao recuperar dados.", "", {
              position: "topRight",
            });
          }
        })
        .finally(() => {
          this.$emit("updateLoadingDados", false);
        });
    },
    getDadosKpisTotalizados() {
      this.loadingPorChave.kpisTotalizados = true;
      return DashboardFaturamentoService.getKpisTotalizados(
        this.competencia,
        this.regionalSelecionada,
      )
        .then((res) => {
          this.dadosKpisTotalizados = res;
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loadingPorChave.kpisTotalizados = false;
        });
    },
    getMetasKpisGeral() {
      this.loadingPorChave.metasKpis = true;
      return DashboardFaturamentoService.getMetasKpisGeral(
        "2023-01",
        dayjs().format("YYYY-MM"),
      )
        .then((res) => {
          this.metasKpis = res;
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loadingPorChave.metasKpis = false;
        });
    },
    getDadosKpisTotalizadosCompetenciaAnterior() {
      this.loadingPorChave.dadosKpisTotalizadosCompetenciaAnterior = true;
      return DashboardFaturamentoService.getKpisTotalizados(
        dayjs(this.competencia)
          .subtract(1, "month")
          .format("YYYY-MM"),
        this.regionalSelecionada,
      )
        .then((res) => {
          this.dadosKpisTotalizadosCompetenciaAnterior = res;
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loadingPorChave.dadosKpisTotalizadosCompetenciaAnterior = false;
        });
    },
    getDadosTipologiaFaturasSemLeitura() {
      this.loadingPorChave.dadosTipologiaFaturasSemLeitura = true;
      return DashboardFaturamentoService.getDadosTipologiaFaturasSemLeitura(
        this.competencia,
        this.regionalSelecionada,
      )
        .then((res) => {
          this.dadosTipologiaFaturasSemLeitura = res;
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loadingPorChave.dadosTipologiaFaturasSemLeitura = false;
        });
    },
    getDadosTipologiaAcertosFaturamento() {
      this.loadingPorChave.dadosTipologiaAcertosFaturamento = true;
      return DashboardFaturamentoService.getDadosTipologiaAcertosFaturamento(
        this.competencia,
        this.regionalSelecionada,
      )
        .then((res) => {
          this.dadosTipologiaAcertosFaturamento = res;
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loadingPorChave.dadosTipologiaAcertosFaturamento = false;
        });
    },
    getDadosKpisPorCompetencia() {
      this.loadingPorChave.dadosCardsKpisPorCompetencia = true;
      return DashboardFaturamentoService.getDadosKpisPorCompetencia(
        "2023-01",
        dayjs().format("YYYY-MM"),
        this.regionalSelecionada,
      )
        .then((res) => {
          this.dadosCardsKpisPorCompetencia = res;
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loadingPorChave.dadosCardsKpisPorCompetencia = false;
        });
    },
  },
  watch: {
    activatedTab() {
      this.getDados();
    },
    competencia() {
      this.getDados();
    },
    regionalSelecionada() {
      this.getDados();
    },
  },
};
</script>

<style></style>
